import { EmailNewsLetterObserver as Tagmanager} from 'core/tag-manager/emailNewsLetter.observer'
import { InputValidationComponent } from 'core/validation/input/input-validation.component'
import { FormValidationComponent } from 'core/validation/form/form-validation.component'
import { ToggleClass } from 'core/toggleClass';
import { constraints } from '../../newsletter/constraints'
import { NewsletterService } from '../../newsletter/newsletter.service'
import { ModalNewsletterObserver } from './modal-newsletter.observer'
import { Observable, Subject } from 'rxjs'

export class ModalNewsLetterComponent {
    constructor() {
        this.newsletterForm = document.querySelector('#newsletter-form-modal')
        if(this.newsletterForm) {
            this.validator = new FormValidationComponent(this.newsletterForm, constraints)
        }
        this.service = new NewsletterService()
        this.modalSelector = document.querySelectorAll('[data-modal="newsletter"]')
        this.modalNewsLetter = document.querySelector('.modal-newsletter')
        this.init()
    }

    init() {
        if(this.modalNewsLetter) {
            if(this.newsletterForm) {
                //Submit NewsLetter Event
                let submitStream = Observable.fromEvent(this.newsletterForm, 'submit')
                    .do(event => event.preventDefault())
                    .filter(() => this.validator.validateForm())
                    .map(event => this.validator.serializeForm())
                    .map(email => this.buildObj(email))
                    .subscribe(data => this.enviarEmail(data))
            }

            //Change Input Event Component
            new InputValidationComponent(this.newsletterForm, constraints).init()
            
            //Modal Aviseme Toggle Click
            new ToggleClass(this.modalSettings())

            //open modal
            document.body.classList.add('block-scroll')
            this.modalNewsLetter.classList.add('modal--active')
        }

    }

    modalSettings() {
        return {
            selector: this.modalSelector,
            target: this.modalNewsLetter,
            class: 'modal--active',
            callback: undefined,
            blockBodyScroll: true
        }
    }

    buildObj(email) {
        return {
            email: email.email,
            origem: this.newsletterForm.getAttribute('data-origem')
        }
    }

    enviarEmail(data) {
        let emailEnviadoSubject = new Subject();
        emailEnviadoSubject.subscribe(new ModalNewsletterObserver())
        emailEnviadoSubject.subscribe(new Tagmanager())

        let btn = document.querySelector("#submit-modal-newsletter");
        btn.innerText = "Enviando..."

        return this.service
                    .enviarEmailNewsLetter(data)
                    .subscribe({
                        next: response => emailEnviadoSubject.next(response),
                        error: error => emailEnviadoSubject.error(error),
                        complete: () => console.log("Complete")
                    });
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-newsletter/modal-newsletter.component.js